import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Box,
  ModalFooter,
  Icon,
} from "@chakra-ui/react";
import Iframe from "react-iframe";
import PrimaryText from "../../../components/PrimaryText";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import FormInput from "../../../components/FormInput";

const PassportModal = ({
  isOpen,
  onClose,
  trDetails = {},
  isPatientPassport = true,
  patientPassport,
  attendantDetails,
}) => {
  const [attendantIndex, setAttendantIndex] = useState(0);

  const [details, setDetails] = useState({
    name: "",
    passportNo: "",
    nationality: "",
    dob: "",
    age: "",
    passportImage: "",
  });

  useEffect(() => {
    if (isPatientPassport && isPatientPassport !== "") {
      setDetails({
        name: trDetails.patient_name,
        passportNo: trDetails.passport_no,
        nationality: trDetails.nationality,
        dob: trDetails.dob,
        age: trDetails.age,
        passportImage: patientPassport,
      });
    } else {
      if (attendantDetails?.length > 0) {
        updateAttendantDetails(attendantIndex);
      }
    }
  }, [trDetails, isPatientPassport, attendantIndex]);

  const updateAttendantDetails = (index) => {
    const currentAttendant = attendantDetails[index];
    setDetails({
      name: currentAttendant.attendant_name,
      passportNo: currentAttendant.passport_no,
      passportImage: currentAttendant.attendant_passport,
    });
  };

  const nextAttendant = () => {
    if (attendantIndex < attendantDetails?.length - 1) {
      setAttendantIndex(attendantIndex + 1);
    }
  };

  const previousAttendant = () => {
    if (attendantIndex > 0) {
      setAttendantIndex(attendantIndex - 1);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      size="4xl"
      isCentered
    >
      <ModalOverlay />
      <ModalContent maxH="90vh" overflowY="scroll">
        <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
          {isPatientPassport
            ? "Patient Passport"
            : `Attender ${attendantIndex + 1}/${attendantDetails?.length}`}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mb="20px"
          >
            <Iframe
              height="250px"
              width="100%"
              src={details.passportImage}
              alt="Passport"
            />
            {!isPatientPassport && attendantDetails?.length > 1 && (
              <>
                <Icon
                  as={ChevronLeftIcon}
                  boxSize="34px"
                  position="absolute"
                  left="-4px"
                  top="35%"
                  transform="translateY(-50%)"
                  cursor="pointer"
                  color={attendantIndex === 0 ? "gray.500" : "blue.500"}
                  onClick={previousAttendant}
                  _hover={{ color: "blue.700" }}
                  isDisabled={attendantIndex === 0}
                />
                <Icon
                  as={ChevronRightIcon}
                  boxSize="34px"
                  position="absolute"
                  right="-4px"
                  top="35%"
                  transform="translateY(-50%)"
                  cursor="pointer"
                  color={
                    attendantIndex === attendantDetails.length - 1
                      ? "gray.500"
                      : "blue.500"
                  }
                  onClick={nextAttendant}
                  _hover={{ color: "blue.700" }}
                  isDisabled={attendantIndex === attendantDetails.length - 1}
                />
              </>
            )}
          </Box>
          <Box>
            <PrimaryText className="modal-text">Full Name</PrimaryText>
            <FormInput
              name="name"
              id="name"
              value={details.name}
              placeholder="Full Name"
              variant="filled"
            />
          </Box>
          <Box>
            <PrimaryText className="modal-text">Passport No</PrimaryText>
            <FormInput
              name="passportNo"
              id="passportNo"
              value={details.passportNo || ""}
              placeholder="Passport No"
              variant="filled"
            />
          </Box>
          {isPatientPassport && (
            <>
              <Box>
                <PrimaryText className="modal-text">Gender</PrimaryText>
                <FormInput
                  name="gender"
                  id="gender"
                  value={trDetails.gender || ""}
                  placeholder="Gender"
                  variant="filled"
                />
              </Box>
              <Box>
                <PrimaryText className="modal-text">Age</PrimaryText>
                <FormInput
                  name="age"
                  id="age"
                  value={details.age || ""}
                  placeholder="Age"
                  variant="filled"
                />
              </Box>
              <Box>
                <PrimaryText className="modal-text">Nationality</PrimaryText>
                <FormInput
                  name="nationality"
                  id="nationality"
                  value={details.nationality || ""}
                  placeholder="Nationality"
                  variant="filled"
                />
              </Box>
              <Box>
                <PrimaryText className="modal-text">D.O.B</PrimaryText>
                <FormInput
                  name="dob"
                  id="dob"
                  value={details.dob || ""}
                  placeholder="DOB"
                  variant="filled"
                />
              </Box>
            </>
          )}
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PassportModal;
